import React from 'react';
import { Card, Row, Col, Spin, Empty, Progress } from 'antd';

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatCurrencyBRL = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(toNumber(value));
};

const TicketMedioAlunoChartV2 = ({ data, loading }) => {
  if (loading) {
    return (
      <Card title="Ticket Médio por Aluno" style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <Spin size="large" tip="Carregando ticket médio por aluno..." />
        </div>
      </Card>
    );
  }

  const rankingBase = Array.isArray(data?.ranking_unidades) ? data.ranking_unidades : [];

  if (!rankingBase.length) {
    return (
      <Card title="Ticket Médio por Aluno" style={{ marginBottom: '24px' }}>
        <Empty description="Sem dados de unidades para calcular ticket médio" />
      </Card>
    );
  }

  const unidadesNormalizadas = rankingBase.map((item) => {
    const alunos = toNumber(item?.alunos);
    const receitaTotal = toNumber(item?.receita_total);

    return {
      unidade: item?.nome || '-',
      alunos,
      receita_total: receitaTotal,
      ticket_medio: alunos > 0 ? receitaTotal / alunos : 0,
    };
  });

  const somaReceitaTotal = unidadesNormalizadas.reduce((acc, item) => acc + item.receita_total, 0);
  const somaAlunos = unidadesNormalizadas.reduce((acc, item) => acc + item.alunos, 0);
  const ticketMedioGeral = somaAlunos > 0 ? somaReceitaTotal / somaAlunos : 0;

  const ranking = [...unidadesNormalizadas]
    .sort((a, b) => b.ticket_medio - a.ticket_medio)
    .slice(0, 6);

  const maiorTicket = ranking.reduce((max, item) => Math.max(max, item.ticket_medio), 0);

  return (
    <Card title="Ticket Médio por Aluno" style={{ marginBottom: '24px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card size="small">
            <div style={{ fontSize: 12, color: '#666' }}>Ticket Médio por Aluno</div>
            <div style={{ fontSize: 28, fontWeight: 600, color: '#13c2c2', lineHeight: 1.2 }}>
              {formatCurrencyBRL(ticketMedioGeral)}
            </div>
          </Card>
        </Col>

        <Col xs={24}>
          <div style={{ display: 'grid', gap: 12 }}>
            {ranking.map((item, index) => {
              const progressPercent = maiorTicket > 0
                ? Math.max(0, Math.min((item.ticket_medio / maiorTicket) * 100, 100))
                : 0;

              return (
                <div key={`${item.unidade}-${index}`}>
                  <Row justify="space-between" style={{ marginBottom: 4 }}>
                    <Col style={{ fontWeight: 500 }}>{item.unidade}</Col>
                    <Col style={{ color: '#13c2c2', fontWeight: 600 }}>
                      {formatCurrencyBRL(item.ticket_medio)}
                    </Col>
                  </Row>
                  <Progress
                    percent={progressPercent}
                    showInfo={false}
                    strokeColor="#13c2c2"
                    trailColor="#f5f5f5"
                  />
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default TicketMedioAlunoChartV2;
